import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { KeyValuePipe } from '@angular/common';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  imports: [
    MatIcon,
    MatButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    KeyValuePipe,
  ],
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  private translate = inject(TranslateService);
  private readonly destroy = new Subject<void>();

  currentLang: string;
  languageList = {
    hu: {
      label: 'Magyar',
    },
    en: {
      label: 'English',
    },
  };

  ngOnInit(): void {
    this.translate.onLangChange.pipe(takeUntil(this.destroy)).subscribe({
      next: (change) => {
        this.currentLang = change.lang;
      },
    });

    this.currentLang = this.translate.currentLang;
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }
}
